import { render, staticRenderFns } from "./SalesRoles.vue?vue&type=template&id=2619b5ce&"
import script from "./SalesRoles.vue?vue&type=script&lang=js&"
export * from "./SalesRoles.vue?vue&type=script&lang=js&"
import style0 from "./SalesRoles.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports